import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Button, Flex, Heading, Image, Stack, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";

interface IHeroWrapper {
  title: string;
  subTitle: string;
  imgUrl: string;
  imgAltText: string;
  buttonLink?: string;
  buttonText?: string;
}
export const HeroWrapper: React.FC<IHeroWrapper> = ({
  title,
  subTitle,
  imgUrl,
  imgAltText,
  buttonLink,
  buttonText,
}) => {
  const router = useRouter();
  return (
    <Stack minH={"40vh"} direction={{ base: "column", md: "row" }}>
      <Flex py={8} flex={1} align={"center"} justify={"flex-start"}>
        <Stack spacing={6} w={"full"} maxW={"lg"}>
          <Heading as={"h1"} fontSize={{ base: "3xl", md: "4xl", lg: "4xl" }}>
            {title}
          </Heading>
          <Text fontSize={{ base: "md", lg: "lg" }} color={"gray.500"}>
            {subTitle}
          </Text>
          {buttonLink && buttonText ? (
            <Button
              size={"md"}
              leftIcon={<ArrowForwardIcon />}
              variant={"outline"}
              w={"10rem"}
              borderColor={"gray.700"}
              onClick={() => router.push(buttonLink)}
              color={"gray.700"}
              _hover={{ background: "none" }}
            >
              {buttonText}
            </Button>
          ) : null}
        </Stack>
      </Flex>
      <Flex flex={1}>
        <Image alt={imgAltText} objectFit={"cover"} src={imgUrl} />
      </Flex>
    </Stack>
  );
};
